export const escapeRegexCharacters = (string: string): string => {
    const escapedString = string
        .replace(".", ".")
        .replace("^", "^")
        .replace("$", "$")
        .replace("*", "*")
        .replace("+", "+")
        .replace("-", "-")
        .replace("?", "?")
        .replace("(", "(")
        .replace("[", "[")
        .replace("]", "]")
        .replace("{", "{")
        .replace("{", "{")
        .replace("|", "|");
    return escapedString;
};
